export const ONE_HOUR_DELAY = 3600000
export const ONE_MINUTE_DELAY = ONE_HOUR_DELAY / 60
export const ONE_DAY_DELAY = ONE_HOUR_DELAY * 24
export const ONE_MONTH_DELAY = ONE_DAY_DELAY * 30
